/*
 * File: c:\Users\j.mazat\Desktop\Autobuy\AutobuyBackOffice\src\Content\Parks\Parks.tsx
 * Project: c:\Users\j.mazat\Desktop\Autobuy\AutobuyBackOffice
 * Created Date: Wednesday July 19th 2023
 * Author: Jonathan Mazat
 * -----
 * Last Modified: Sunday, 14th January 2024 05:23:02
 * Modified By: Simon (s.gourlet@autobuy.fr>)
 * -----
 * Copyright (c) 2023 Autobuy SAS
 * -----
 */

import translator from "MultiLanguage/TranslationWrapper";
import ParkService from "Services/ParkService/ParkService";
import { ParkType, ParkUpdateType } from "Type/park.type";
import { TableCell, TableRow } from "@mui/material";
import { useState, MouseEvent, useEffect, useRef } from "react";
import Actions from "Content/Actions/Actions";
import ModalPark from "Content/Modals/ModalPark/ModalPark";
// import { useNavigate } from "react-router-dom";
// import RouterPathResolver from "Config/Router/RouterPathResolver";

function ParkRow(props: ParkType) {
    // const navigate = useNavigate();
    const firstLoad = useRef(true);
    const [park, setPark] = useState<ParkUpdateType>({
        Name: props.Name,
        Address: props.Address,
        PostalCode: props.PostalCode,
        City: props.City,
        State: props.State,
        Country: props.Country,
    });
    const [updatableFileds, setUpdatableFileds] = useState({
        Name: undefined,
        Address: undefined,
        PostalCode: undefined,
        City: undefined,
        State: undefined,
        Country: undefined,
    });
    const [showModalParkModify, setShowModalParkModify] = useState(false);

    useEffect(() => {
        if (!firstLoad.current)
            setPark(updatableFileds);
        else
            firstLoad.current = false;
    }, [updatableFileds]);

    const openModifyModalPark = (e: any) => {
        e.stopPropagation();
        setShowModalParkModify(true);
    };
    const closeModifyParkModal = (e: MouseEvent<HTMLElement>) => {
        setShowModalParkModify(false);
    };

    // const updatePark = async (data: ParkType) => {
    //     const myRet = await ParkService.UpdatePark(data);
    //     return myRet;
    // };

    // const handleDeletePark = async (e: any, parkID: string) => {
    //     e.stopPropagation();
    //     if (window.confirm(translator.decode("dynamic.confirmDeletePark"))){
    //         await ParkService.deletePark(parkID)
    //         .then(res => {
    //             if (res.status === 200)
    //                 window.alert(translator.decode("dynamic.deleteSuccess"));
    //         }).catch((reason: any) => {
    //             if (reason.response.status >= 400)
    //                 window.alert(translator.decode("dynamic.deleteFailed"));
    //         });
    //     }
    // };

    // const submitPark = async (data: ParkSendType) => {
    //     const myRet = await ParkService.CreatePark(data);
    //     return myRet;
    // };

    return(
        // <TableRow style={props.style}>
        <TableRow>
            {/* <TableCell sx={{cursor:"pointer"}} onClick={() => navigate(RouterPathResolver.pathCompany_BY_ID.path.replace(":id", props.id))}> */}
            <TableCell>
                {park.Name}
            </TableCell>
            <TableCell>
                {park.Address}
            </TableCell>
            <TableCell>
                {park.City}
            </TableCell>
            <TableCell>
                {park.PostalCode}
            </TableCell>
            <TableCell>
                {park.State}
            </TableCell>
            <TableCell>
                {park.Country}
            </TableCell>
            <TableCell>
                <Actions variant={"minimal"} disabled={false} manageUpdate={openModifyModalPark} />
            </TableCell>
            <ModalPark updatePark={setUpdatableFileds} ParkID={props.id} data={park} submitFunc={ParkService.UpdatePark} title={translator.decode("dynamic.parks")} show={showModalParkModify} onClose={closeModifyParkModal} closeModal={closeModifyParkModal} />
        </TableRow>
    )
};

export default ParkRow;
